import axios from 'axios';
import logger from '../utils/logger';

import { getJwtToken } from './jwt.services';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your API's base URL

const scriptRunnerService = {
	getScripts: async () => {
		try {
			const jwtToken = getJwtToken();
			const apiUrl = `${BASE_URL}/script-runner/scripts/`;
			logger.debug({ apiUrl });
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json',
			};
			const response = await axios.get(apiUrl, { headers });
			logger.debug({
				message: 'got data from the back-end',
				data: response.data.activeScripts,
			});
			return response.data.activeScripts;
		} catch (error) {
			logger.error({ message: 'Error in getScripts ', error });
		}
	},
	
	getScriptsWithPagination: async (pageNumber = 1, pageSize = 15, searchTerm = '', sortBy = 'name', sortOrder = 'asc') => {
		try {
			const jwtToken = getJwtToken();
			const params = new URLSearchParams({
				pageNumber: pageNumber.toString(),
				pageSize: pageSize.toString(),
				sortBy,
				sortOrder
			});
			
			if (searchTerm && searchTerm.trim()) {
				params.append('search', searchTerm.trim());
			}
			
			const apiUrl = `${BASE_URL}/script-runner/scripts?${params.toString()}`;
			logger.debug({ apiUrl, searchTerm, pageNumber, pageSize });
			
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json',
			};
			
			const response = await axios.get(apiUrl, { headers });
			logger.debug({
				message: 'got paginated scripts from the back-end',
				data: response.data,
			});
			
			return {
				scripts: response.data.scripts || [],
				pagination: response.data.pagination || {},
				search: response.data.search || ''
			};
		} catch (error) {
			logger.error({ message: 'Error in getScriptsWithPagination', error });
			throw error;
		}
	},
	createJob: async (formData, selectedScript) => {
		try {
			logger.debug({ message: 'in createjob function' });
			const jwtToken = getJwtToken();
			const apiUrl = `${BASE_URL}/script-runner/create-job/`;
			const jsonData = {
				script: selectedScript,
				input: { formData },
			};
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json', // Adjust the content type if needed
			};
			logger.debug({ apiUrl, jsonData });
			const response = await axios.post(apiUrl, jsonData, { headers });
			logger.debug({
				message: 'Created job',
				response,
			});
			return response.data.activeScripts;
		} catch (error) {
			logger.error({ message: 'Error in createJob ', error: error.message });
			throw error;
		}
	},
	getJobs: async (pageNumber, pageSize, searchTerm = '', sortBy = '_id', sortOrder = 'desc') => {
		const jwtToken = getJwtToken();

		try {
			const params = new URLSearchParams({
				pageNumber: pageNumber.toString(),
				pageSize: pageSize.toString(),
				sortBy,
				sortOrder
			});
			
			if (searchTerm && searchTerm.trim()) {
				params.append('search', searchTerm.trim());
			}
			
			const apiUrl = `${BASE_URL}/script-runner/jobs?${params.toString()}`;
			const headers = {
				Authorization: `Bearer ${jwtToken}`,
				'Content-Type': 'application/json',
			};
			logger.debug({ apiUrl, searchTerm, pageNumber, pageSize, sortBy, sortOrder });
			const response = await axios.get(apiUrl, { headers });
			logger.debug({
				message: 'got jobs from the backend',
				data: response.data,
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	},
	downloadFiles: async (jobId) => {
		const jwtToken = getJwtToken();
		const fileUrl = `${BASE_URL}/script-runner/download-files?jobId=${jobId}`;

		try {
			const response = await fetch(fileUrl, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${jwtToken}`, // Replace with your actual auth token
				},
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);

			// Create a temporary link element
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.target = '_blank';
			link.download = `${jobId}.zip`; // Specify the desired file name

			// Trigger a click event on the link to initiate the download
			document.body.appendChild(link); // Required for Firefox
			link.click();
			document.body.removeChild(link); // Clean up

			window.URL.revokeObjectURL(downloadUrl); // Clean up

			return { success: true };
		} catch (error) {
			logger.error('Download failed:', error);
			return { success: false, error: error.message };
		}
	},
};
export default scriptRunnerService;
